import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Inquiries from './components/Inquiries';
import Gallery from './components/Gallery';
import SiteContent from './components/SiteContent';
import Navbar from './components/Navbar';
import NotificationSettings from './components/NotificationSettings';
import TelegramSettings from './components/TelegramSettings';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await fetch('/api/auth/verify', {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          setIsAuthenticated(response.ok);
        } catch {
          setIsAuthenticated(false);
        }
      }
      setLoading(false);
    };
    verifyToken();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <Router>
      {isAuthenticated && <Navbar onLogout={() => setIsAuthenticated(false)} />}
      <Routes>
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login onLoginSuccess={() => setIsAuthenticated(true)} />}
        />
        <Route 
          path="/dashboard" 
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route 
          path="/settings" 
          element={isAuthenticated ? <Settings /> : <Navigate to="/login" />}
        />
        <Route
          path="/inquiries"
          element={isAuthenticated ? <Inquiries /> : <Navigate to="/login" />}
        />
        <Route
          path="/gallery"
          element={isAuthenticated ? <Gallery /> : <Navigate to="/login" />}
        />
        <Route
          path="/site-content"
          element={isAuthenticated ? <SiteContent /> : <Navigate to="/login" />}
        />
        <Route
          path="/notifications"
          element={isAuthenticated ? <NotificationSettings /> : <Navigate to="/login" />}
        />
        <Route
          path="/telegram-settings"
          element={isAuthenticated ? <TelegramSettings /> : <Navigate to="/login" />}
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;
